module.exports = __webpack_public_path__ + "static/img/logo.bcd69b52.svg";